export default __webpack_public_path__ + "static/media/hero_img_mobile.78497a18.jpg";